<template>
    <div class="technician-page">
        <div class="pc-page" v-if="$padFalg != 'other'">
            <div class="area1">
                <gameInfoTitle class="area1-title" title="人物立繪"></gameInfoTitle>
                <div class="base-info">
                    <div class="base-info-pc">
                        <div class="base-info-name">
                            <p class="base-info-name-text">{{ detailData.name }}</p>
                            <div :class="`base-info-occupation-${detailData.occIcon}`"></div>
                        </div>
                        <div class="detail-wrap">
                            <div class="base-info-detail">
                            <baseInfoWrap class="base-info-detail-record" textColor="#ccd0d2" title="DANG AN">
                                <div class="record-wrap">
                                    <div v-for="(item, index) in detailData.technianRecordData" class="record-wrap-content"
                                        :key="index">
                                        <div class="content-attr">{{ item.title }}</div>
                                        <div class="content-text">{{ item.content }}</div>
                                    </div>
                                </div>
                            </baseInfoWrap>
                        </div>
                        <div class="base-info-desc">
                            <p class="base-info-desc-title">簡介</p>
                            <div class="base-info-desc-wrap">
                                <p class="base-info-desc-text">{{ detailData.desc }}</p>
                            </div>
                        </div>
                        </div>

                        <div class="base-info-live">
                            <img :src="detailData.liveSrc" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div class="area2">
                <div class="area2-left-area">
                    <div class="area2-left-title">
                        <gameInfoTitle title="基礎資訊">
                            <switchInfo @switch="switchBaseInfoFullLevel" :status="baseInfoFullLevel"></switchInfo>
                        </gameInfoTitle>
                    </div>
                    <div class="area2-left-content">
                        <baseInfo :originData="detailData" :isFullLevel="baseInfoFullLevel"></baseInfo>
                    </div>
                </div>
                <div class="area2-right-area">
                    <div class="area2-right-title">
                        <gameInfoTitle title="角色天賦">
                            <switchInfo desc="升級天賦" switchDesc="初始天賦" @switch="switchTalentFullLevel" :status="talentFullLevel"></switchInfo>
                        </gameInfoTitle>
                    </div>
                    <div class="area2-right-content">
                        <talent :originData="detailData" :isFullLevel="talentFullLevel"></talent>
                    </div>
                </div>
            </div>
            <div class="area3">
                <div class="area3-title">
                    <gameInfoTitle title="仿生電腦">
                    </gameInfoTitle>
                </div>
                <div class="area3-content">
                    <neuralComputer :originData="detailData"></neuralComputer>
                </div>
            </div>
            <div class="area4">
                <div class="area4-title">
                    <gameInfoTitle title="神經驅動">
                    </gameInfoTitle>
                </div>
                <div class="area4-content">
                    <neuralDrive :originData="detailData"></neuralDrive>
                </div>
            </div>

        </div>
        <div class="mobile-page" v-else>
            <div class="area1">
                <gameInfoTitle class="area1-title" title="人物立繪"></gameInfoTitle>
                <div class="base-info">
                    <div class="base-info-m">
                        <div class="base-info-name">
                            <p class="base-info-name-text">{{ detailData.name }}</p>
                        </div>
                        <div class="base-info-live">
                            <img :src="detailData.liveSrc" alt="">
                        </div>
                        <div class="base-info-occupation">
                            <div :class="`base-info-occupation-${detailData.occIcon}`"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="area2">
                <switchBar @changeTab="changeTab" class="area2-switch-bar" :barData="barData"></switchBar>
                <div class="area2-switch-info">
                    <switchInfo v-if="currentTabComponent == 'baseInfo' || currentTabComponent == 'talent'"
                        @switch="switchMobileLevel" :status="mobileFullLevel"></switchInfo>
                </div>
                <component class="area2-dynamic-components" direction="vertical" :originData="detailData"
                    :style="{ height: currentTabComponent == 'baseInfo' || currentTabComponent == 'talent' ? '3.7rem' : '' }"
                    :isFullLevel="mobileFullLevel" v-bind:is="currentTabComponent"></component>
            </div>
        </div>
    </div>
</template>

<script>
import gameInfoTitle from '../components/gameInfoTitle.vue';
import baseInfoWrap from '../components/base/baseInfoWrap.vue';
import switchInfo from '../components/base/switchInfo.vue';
import baseInfo from '../components/baseInfo.vue';
import talent from '../components/talent.vue';
import switchBar from '../components/base/switchBar.vue';
import neuralComputer from '../components/neuralComputer.vue';
import neuralDrive from '../components/neuralDrive.vue';
import technicianRecord from '../components/technicianRecord.vue';
export default {
    components: { gameInfoTitle, baseInfoWrap, switchInfo, baseInfo, talent, switchBar, neuralComputer, neuralDrive, technicianRecord },
    props: {
        detailData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            barData: [
                {
                    title: '基礎資訊',
                    cb: 'baseInfo'
                },
                {
                    title: '角色天賦',
                    cb: 'talent'
                },
                {
                    title: '仿生電腦',
                    cb: 'neuralComputer'
                },
                {
                    title: '神經驅動',
                    cb: 'neuralDrive'
                },
                {
                    title: '機師档案',
                    cb: 'technicianRecord'
                }
            ],
            currentTabComponent: 'baseInfo',
            baseInfoFullLevel: false,
            talentFullLevel: false,
            mobileFullLevel: false
        }
    },
    methods: {
        switchBaseInfoFullLevel(status) {
            this.baseInfoFullLevel = status
        },
        switchTalentFullLevel(status) {
            this.talentFullLevel = status
        },
        changeTab(component) {
            this.mobileFullLevel = false
            this.currentTabComponent = component;
        },
        switchMobileLevel(status) {
            this.mobileFullLevel = status
        }
    }
}
</script>

<style lang="scss" scoped>
.technician-page {

    .mobile-page,
    .pc-page {
        position: relative;
    }

    .mobile-page {
        .area1 {
            margin-bottom: .3rem;

            &-title {
                margin-bottom: 0.14rem;
            }

            .base-info {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;

                &-m {
                    .base-info-name {
                        position: absolute;
                        top: .9rem;
                        left: .2rem;
                        width: 2.37rem;
                        height: .81rem;
                        box-sizing: border-box;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        p {
                            color: #d45456;
                            font-weight: bold;
                            font-size: .59rem;
                        }
                    }

                    .base-info-live {
                        position: absolute;
                        left: 0;
                        right: 0;
                        //width: 3.85rem;
                        height: 100%;
                        margin: 0 auto;
                        overflow-y: clip;

                        img {
                            width: 100%;
                            height: 100%;
                            object-position: bottom;
                            object-fit: cover;
                            filter: drop-shadow(-.2rem .1rem 0 #00000059);
                            object-position: 50% .4rem;
                        }

                        img[src=""],
                        img:not([src]) {
                            opacity: 0;
                        }
                    }

                    .base-info-occupation {
                        position: absolute;
                        top: 3.48rem;
                        right: .22rem;
                    }
                }


            }
        }

        .area2 {
            .area2-switch-bar {
                margin-bottom: .15rem;
            }

            .area2-switch-info {
                display: flex;
                justify-content: flex-end;
                align-items: center;
                margin-bottom: .15rem;
            }
        }
    }

    .pc-page {
        .area1 {
            margin-bottom: .3rem;

            &-title {
                margin-bottom: 0.14rem;
            }

            .base-info {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                position: relative;

                &-pc {
                    position: relative;

                    .base-info-name {
                        position: absolute;
                        top: .2rem;
                        left: .19rem;
                        width: 5.11rem;
                        height: .81rem;
                        padding: 0 .46rem;
                        box-sizing: border-box;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        p {
                            color: #d45456;
                            font-weight: bold;
                            font-size: .59rem;
                        }
                    }

                    .detail-wrap{
                        position: absolute;
                        width: 5.11rem;
                        left: .19rem;
                        top: 1.24rem;
                        max-height: 5.8rem;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        .base-info-detail {
                        position: relative;
                        width: 5.11rem;
                        height: fit-content;
                        left: 0rem;
                        top: 0rem;

                        &-record {
                            .record-wrap {
                                height: 100%;
                                padding: .18rem .4rem;
                                display: flex;
                                flex-direction: column;
                                justify-content: space-between;
                                box-sizing: border-box;

                                &-content {
                                    display: flex;
                                    align-items: center;
                                    justify-content: flex-start;

                                    font-size: .24rem;

                                    .content-attr {
                                        font-weight: bold;
                                        width: 2rem;

                                    }

                                    .content-text {
                                        font-size: .2rem;
                                        flex: 1;
                                    }
                                }
                            }
                        }
                    }

                    .base-info-desc {
                        position: relative;
                        width: 5.5rem;
                        flex: 1;
                        left: 0rem;
                        top: 0rem;
                        padding: .1rem .35rem;
                        box-sizing: border-box;
                        overflow: hidden;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        justify-content: center;
                        

                        ::-webkit-scrollbar {
                            -webkit-appearance: none;
                        }

                        ::-webkit-scrollbar:vertical {
                            width: .3vw;
                        }

                        ::-webkit-scrollbar:horizontal {
                            height: 0;
                        }

                        ::-webkit-scrollbar-thumb {
                            background-color: black;
                            // border-radius: 1vw;
                            border: 0px solid black;
                        }

                        ::-webkit-scrollbar-track {
                            // border-radius: 1vw;
                            background-color: white;
                        }

                        &-title {
                            font-size: .28rem;
                            font-weight: 600;
                        }

                        &-wrap {
                            flex: 1;
                            overflow-y: auto;
                            padding-right: .1rem;

                            .base-info-desc-text {
                                font-size: .22rem;
                            }
                        }


                    }
                    }



                    .base-info-live {
                        position: absolute;
                        top: 0;
                        //width: 5.4rem;
                        height: 100%;
                        right: -2rem;
                        overflow-y: clip;

                        img {
                            width: auto;
                            height: 100%;
                            object-position: bottom;
                            object-fit: cover;
                            filter: drop-shadow(-.2rem .1rem 0 #00000059);
                            object-position: 50% .4rem;
                            mask-image: linear-gradient(to left, #000000 70%, #0000002d 80%, #00000000 100%);
                        }

                        img[src=""],
                        img:not([src]) {
                            opacity: 0;
                        }
                    }
                }


            }
        }

        .area2 {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            margin-bottom: .3rem;

            &-left-area,
            &-right-area {
                width: 5.4rem;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                justify-content: center;
            }

            &-left-area {
                .area2-left-title {
                    width: 100%;
                    margin-bottom: .02rem;
                }

                .area2-left-content {
                    width: 95%;
                    flex: 1;
                }
            }

            &-right-area {
                .area2-right-title {
                    width: 100%;
                    margin-bottom: .02rem;
                }

                .area2-right-content {
                    width: 95%;
                    flex: 1;
                }
            }
        }

        .area3 {
            margin-bottom: .3rem;

            &-title {
                margin-bottom: .2rem;
            }

            &-content {
                display: flex;
                align-items: center;
                justify-content: center;

            }
        }

        .area4 {
            &-title {
                margin-bottom: .2rem;
            }

            &-content {
                display: flex;
                align-items: center;
                justify-content: center;

            }
        }
    }
}
</style>